<script>
  import Fa from 'svelte-fa'
  import { faLinkedin,  faVimeo} from '@fortawesome/free-brands-svg-icons'
</script>
<main>
	<header>
		<h1>Luke Gaines</h1>
		<div id="links">
			<a href="https://www.linkedin.com/in/luke-gaines-943066138/">
				<Fa icon={faLinkedin} />
			</a>
			<div class="spacer"></div>
			<a href="https://vimeo.com/callistoentertainment">
				<Fa icon={faVimeo} />
			</a>
		</div>
	</header>
	<!-- <div id="vid">
	</div> -->
	<div id="vid"><iframe src="https://player.vimeo.com/video/675684038?h=52de933eac&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Student Production Reel"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
</main>

<style>
	#links {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}
	#links > a {
		color: #ffebe4;
		text-decoration: none;
		font-size: 2em;
	}
	#links > a:hover {
		color: rgb(0, 173, 239);
	}
	#links > .spacer {
		margin: 0.5em
	}
	#vid {
		width: 80vw;
		min-height: 80vh;
		position:relative;
	}

	main {
		padding: 1em;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	header {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		flex: 1;
		width: 100%;
		margin-bottom: 1em;
		cursor:default;
	}
	h1 {
		color: #ffebe4;
		font-size: 4em;
		font-weight: 100;
		margin-top: 0em;
		margin-bottom: 0em;
	}

	@media (max-width: 640px) {
		main {
			max-width: none;
		}
		h1 {
		font-size: 3em;
		}
		header {
			flex-direction: column;
			align-items: center;
			margin-bottom: 1em;
		}
		#vid {
			min-height: 40vh;
		}
	}
</style>